export function formatObject2String(obj) {
    if (obj && typeof obj === 'object') {
        let arr = [];
        Object.keys(obj).forEach((key) => {
            if (obj[key]) {
                arr.push(`${key}: ${obj[key]}`);
            }
        });

        return arr.join(', ');
    }
    return '';
}

export function formatBuffer2HexString(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), function (bit) {
        return ('00' + bit.toString(16)).slice(-2).toUpperCase();
    }).join(' ');
}
